export default __webpack_public_path__ + "static/media/main_saying03_kr.4ffd3642.png";